
export const extractTextFromTextFile = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const text = e.target.result;
        resolve(text);
      } catch (error) {
        reject(new Error("Failed to read text file"));
      }
    };
    reader.onerror = () => reject(new Error("Failed to read text file"));
    reader.readAsText(file);
  });
};

export const loadPDFJS = async () => {
  return new Promise((resolve, reject) => {
    if (window['pdfjs-dist/build/pdf']) {
      resolve();
      return;
    }
    
    const script = document.createElement('script');
    script.src = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js';
    script.onload = () => {
      // Set worker path
      window['pdfjs-dist/build/pdf'].GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';
      resolve();
    };
    script.onerror = () => reject(new Error("Failed to load PDF.js"));
    document.head.appendChild(script);
  });
};
export const extractTextFromPDF = async (file, onProgress = null) => {
  try {
    const arrayBuffer = await file.arrayBuffer();
    const pdfjsLib = window['pdfjs-dist/build/pdf'];
    
    if (!pdfjsLib) {
      await loadPDFJS();
    }
    
    const loadingTask = pdfjsLib.getDocument({ data: arrayBuffer });
    const pdf = await loadingTask.promise;
    
    let fullText = "";
    
    for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
      const page = await pdf.getPage(pageNum);
      const textContent = await page.getTextContent();
      const pageText = textContent.items.map(item => item.str).join(' ');
      fullText += pageText + '\n\n';
            if (onProgress) {
        const progress = (pageNum / pdf.numPages) * 100;
        onProgress(progress);
      }
    }
    
    return fullText.trim() || "No text content found in PDF";
  } catch (error) {
    console.error("PDF extraction error:", error);
    return await extractTextFromPDFFallback(file);
  }
};
export const extractTextFromPDFFallback = async (file) => {
  try {
    const text = await file.text();
    if (text && text.length > 100) {
      return text;
    }
    throw new Error("PDF text extraction failed");
  } catch (error) {
    throw new Error("Unable to extract text from PDF. Please ensure the PDF contains selectable text.");
  }
};

export const extractTextFromWordDocument = async (file) => {
  try {
    const text = await file.text();
    
    // Check if we got meaningful content
    if (text && text.length > 50 && !text.includes('PK')) {
      // Clean up the text (remove XML tags and formatting)
      const cleanText = text
        .replace(/<[^>]*>/g, ' ') // Remove XML tags
        .replace(/\s+/g, ' ') // Normalize whitespace
        .replace(/[^\w\s.,!?;:()[\]{}"'`~@#$%^&*+=<>/\\|]/g, '') // Remove special characters
        .trim();
      
      return cleanText || "No readable text found in document";
    }
    
    // If text extraction failed, try alternative method
    return await extractTextFromWordDocumentFallback(file);
  } catch (error) {
    console.error("Word document extraction error:", error);
    return await extractTextFromWordDocumentFallback(file);
  }
};


export const extractTextFromWordDocumentFallback = async (file) => {
  try {
    // Try to read as array buffer and look for text content
    const arrayBuffer = await file.arrayBuffer();
    const uint8Array = new Uint8Array(arrayBuffer);
    
    // Convert to string and look for readable text
    const decoder = new TextDecoder('utf-8');
    const text = decoder.decode(uint8Array);
    
    // Extract text between common Word document markers
    const textMatches = text.match(/[A-Za-z0-9\s.,!?;:()[\]{}"'`~@#$%^&*+=<>/\\|]{50,}/g);
    
    if (textMatches && textMatches.length > 0) {
      return textMatches.join('\n\n');
    }
    
    throw new Error("No readable text found in Word document");
  } catch (error) {
    throw new Error("Unable to extract text from Word document. Please ensure the document contains readable text.");
  }
};
export const extractTextFromFile = async (file, onProgress = null) => {
  try {
    let extractedText = "";

    if (file.name.endsWith(".txt")) {
      if (onProgress) onProgress(50);
      extractedText = await extractTextFromTextFile(file);
      if (onProgress) onProgress(100);
    } else if (file.name.endsWith(".pdf")) {
      extractedText = await extractTextFromPDF(file, onProgress);
    } else if (file.name.endsWith(".doc") || file.name.endsWith(".docx")) {
      if (onProgress) onProgress(50);
      extractedText = await extractTextFromWordDocument(file);
      if (onProgress) onProgress(100);
    } else {
      throw new Error("Unsupported file type. Please upload PDF, Word document, or text file.");
    }

    if (!extractedText || extractedText.trim().length === 0) {
      throw new Error("No text content could be extracted from the file.");
    }

    return extractedText;
  } catch (error) {
    console.error("Text extraction error:", error);
    throw error;
  }
};

